import React from "react";

export const AI_CARD = "bg-white rounded-2xl border border-gray-200/70 shadow-[0_1px_3px_rgba(16,24,40,0.04)]";
export const AI_INPUT = "w-full h-10 px-3.5 text-sm text-gray-900 placeholder:text-gray-400 bg-white border border-gray-200 rounded-xl hover:border-gray-300 focus:outline-none focus:ring-4 focus:ring-purple-500/10 focus:border-purple-400 transition-all";
export const AI_BTN = "inline-flex items-center justify-center gap-2 h-10 px-4 rounded-xl text-sm font-semibold bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-md shadow-purple-600/20 hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all";
export const AI_LABEL = "text-[11px] font-semibold uppercase tracking-wider text-gray-400";

/**
 * AIPanel — card with a consistent header (icon tile, title, description,
 * optional action on the right) used by every VendorLift tool.
 */
const AIPanel = ({ icon: Icon, title, description, action, children, className = "" }) => (
  <div className={`${AI_CARD} p-5 sm:p-6 ${className}`}>
    <div className="flex items-start justify-between gap-3 mb-5">
      <div className="flex items-center gap-3 min-w-0">
        {Icon && (
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-purple-600 to-pink-600 shadow-md shadow-purple-600/20">
            <Icon className="h-5 w-5 text-white" />
          </div>
        )}
        <div className="min-w-0">
          <h3 className="font-['Manrope'] text-base font-bold text-gray-900 leading-tight">{title}</h3>
          {description && <p className="mt-0.5 text-xs text-gray-500">{description}</p>}
        </div>
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
    {children}
  </div>
);

export default AIPanel;
